import React from "react";
import { useTranslation } from "react-i18next";

/** Material-UI */
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        gap: 8,
        width: "100%",
        flexWrap: "wrap",
        fontSize: "clamp(13px, 1vw, 1rem)",
        fontWeight: 600,
        '& + &':{
            paddingTop:8
        },
        [theme.breakpoints.down("xs")]: {
            gap: 0,
        },
    },
    sublist: {
        width: "100%",
        padding: theme.spacing(0, 0, 0, 0),
        marginLeft:16
    },
    itemObject: {
        fontSize: "clamp(14px, 2vw, 1.125rem)",
        fontWeight: 400,
        "& span": {
            fontWeight: 600,
        },
    },
    itemSystem: {
        fontSize: "clamp(14px, 2vw, 1.125rem)",
        fontWeight: 400,
        "& span": {
            fontWeight: 600,
        },        
    },
}));

const ObjectCard = ({ obiekt, selected }) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <>
            <li className={classes.container} >
                <span className={classes.itemObject}>
                    {t("obiekt.nazwa_obiektu")}
                    {":"}&nbsp;
                    <span>{obiekt.nazwa_obiektu}</span>
                </span>
                {!!obiekt.systemy.length && (
                    <ul className={classes.sublist}>
                        {obiekt.systemy.map((system, index) => {
                            return (
                                <React.Fragment key={`${system.id_systemu}-k${index}`}>
                                    <li className={classes.container}>
                                        <span className={classes.itemSystem}>
                                            {t("system.nazwa_systemu")}
                                            {":"}&nbsp;
                                            <span>{system.nazwa_systemu}</span>
                                        </span>
                                    </li>
                                    <li className={classes.container}>
                                        <span className={classes.itemSystem}>
                                            {t("system.gestor")}
                                            {":"}&nbsp;
                                            <span>{system.gestor}</span>
                                        </span>
                                    </li>
                                </React.Fragment>
                            );
                        })}
                    </ul>
                )}
            </li>
        </>
    );
};

export default ObjectCard;
